<div>
<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.request')}} #{{sender.displayId}}
                    </label>
                </div>
                <div class="col-auto">
                    <router-link v-if="(userRole == 2 ||userRole == 5) && sender.requestStatus == 3" :to="'/Dashboard/EditSender/' + id" tag="button" class="btn btn-success px-4">{{$t('shared.edit')}}</router-link>
                    <v-menu offset-y open-on-hover>
                        <template v-slot:activator="{ on }">
                            <v-btn color="btn-primary"
                                   v-on="on">
                                <div>{{$t('shared.actionHere')}}</div>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile v-if="(userRole == 2 ||userRole == 5) && sender.requestStatus == 2" @click="PreparePay()">
                                <v-list-tile-title class="white">{{$t('dashboardPage.Pay')}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="(userRole == 1  || userRole == 9 || userRole == 15) && sender.requestStatus == '1' && ((userRole == 1 && sender.tenantId == tenantId) || userRole != 1) " @click="showapproveDialog()">
                                <v-list-tile-title class="white">{{$t('dashboardPage.Approve')}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="userRole == 9 && sender.requestStatus == '10'" @click="showFinalApproveDialog()">
                                <v-list-tile-title class="white">{{$t('dashboardPage.finalApprove')}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="canDeactivateCurrentSender()" @click="showDeactivateDialog()">
                                <v-list-tile-title class="white">{{$t('dashboardPage.deactivate')}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="((userRole == 2 ||userRole == 5) && !providerLocked) && sender.requestStatus == 3" @click="showresendDialog()">
                                <v-list-tile-title class="white">{{$t('dashboardPage.resend')}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if="(userRole == 1  || userRole == 9 || userRole == 15) && ((userRole == 1 && sender.tenantId == tenantId) || userRole != 1) && (sender.requestStatus == '1' || (sender.requestStatus == '10' && userRole == 9 ))" @click="showRejectDialog()">
                                <v-list-tile-title class="white">{{$t('dashboardPage.reject')}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if=" (userRole == 1  || userRole == 9) && ((userRole == 1 && sender.tenantId == tenantId) || userRole != 1)  && (sender.requestStatus == '4' || sender.requestStatus == '2') &&  !sender.isCriticalSender" @click="showDeleteDialog(sender.id)">
                                <v-list-tile-title class="white">{{$t('shared.delete')}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-if=" (userRole == 2 ||userRole == 5) && (sender.requestStatus == 4 || sender.requestStatus == 5)" @click="showExtendRequests()">
                                <v-list-tile-title class="white">{{$t('shared.showExtendRequest')}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="showSenderRequestTransactions()">
                                <v-list-tile-title class="white">{{$t((userRole == 3 || userRole == 4) ? 'shared.showSenderActivityHistory' : 'shared.showSenderRequestActions')}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <!-- =================== -->
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-header p-0" v-if="showTabs">
                    <v-tabs center-active v-model="activeTab" background-color="white" color="primary" slider-color="primary" grow class="card-tabs">
                        <v-tab class="half-tab">{{ $t('shared.details') }}</v-tab>
                        <v-tab class="half-tab">{{ $t('shared.aiAttachmentReview') }}</v-tab>
                    </v-tabs>
                </div>
                <div class="card-body card_body_layout" style="padding-top: 10px;">
                    <template v-if="showTabs">
                    <v-tabs-items v-model="activeTab">
                    <!-- Details Tab -->
                    <v-tab-item >
                        <div>
                            <div class="row">                                
                                <div v-if="showScamListWarning" class="col-md-9">
                                    <v-icon x-large style="color:red">warning_amber</v-icon><span style="color: red; top: -10px; position: relative;" v-html="scamListWarningHtml"></span>
                                </div>
                            </div>
                    <div class="row">
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('dashboardPage.senderName')}}</label>
                                    <img v-if="sender.isAutoSuggested && (userRole == 1 || userRole == 9 || userRole == 15)"
                                         :title="$t('shared.senderNameByAI')"
                                         :src="require('../../img/AISuggested.png')" alt="Icon" style="width: 20px; height: 20px; margin-right: 8px;" />
                                    <h4 class="user_info_txt">{{sender.senderName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.senderType')}}</label>
                                    <h4 class="user_info_txt">
                                        <span v-for="(type, index) in senderType" :key="type">
                                            {{getSenderTypeText(type)}}
                                        </span>
                                    </h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.domainName">
                                    <label class="user_info_header mb-0">{{ $t('shared.domainName') }}</label>
                                    <h4 class="user_info_txt">{{ sender.domainName }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.hasTrademark">
                                    <label class="user_info_header mb-0">{{ $t('shared.trademarkName') }}</label>
                                    <h4 class="user_info_txt">{{ sender.trademarkName }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.hasTrademark">
                                    <label class="user_info_header mb-0">{{ $t('shared.protectionDateFrom') }}</label>
                                    <h4 class="user_info_txt">{{ sender.protectionDateFrom }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.hasTrademark">
                                    <label class="user_info_header mb-0">{{ $t('shared.protectionDateTo') }}</label>
                                    <h4 class="user_info_txt">{{ sender.protectionDateTo }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="(userRole != 2  && userRole != 5)">
                                    <label class="user_info_header mb-0">{{$t('shared.providerName')}}</label>
                                    <h4 class="user_info_txt">{{sender.providerName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.clientName')}}</label>
                                    <h4 class="user_info_txt">{{sender.clientName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.customerType !== 3">
                                    <label class="user_info_header mb-0" v-if="sender.customerType === 1">{{$t('shared.budgetNumber')}}</label>
                                    <label class="user_info_header mb-0" v-if="sender.customerType === 2">{{$t('shared.licenseNumber')}}</label>
                                    <label class="user_info_header mb-0" v-if="sender.customerType === 4">{{$t('shared.internationalCommercialRegistrationNumber')}}</label>
                                    <h4 class="user_info_txt no-collapse">{{sender.crNumber}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.customerType === 2 ||sender.customerType === 3">
                                    <label class="user_info_header mb-0">{{$t('shared.enterpriseUnifiedNumber')}}</label>
                                    <img v-if="sender.verificationType == 1  && (userRole == 1 || userRole == 9 || userRole == 15)"
                                         :title="$t('shared.crAutoVerificationSuccess')"
                                         :src="require('../../img/success_tick_icon.svg')" alt="Icon" style="width: 20px; height: 20px; margin-right: 8px;"/>
                                    <h4 class="user_info_txt no-collapse">{{sender.enterpriseUnifiedNumber}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.customerType')}}</label>
                                    <h4 class="user_info_txt">{{getCustomerTypeText(sender.customerType)}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.representativeName')}}</label>
                                    <h4 class="user_info_txt">{{ maskedRepresentativeName }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.representativeEmail')}}</label>
                                    <h4 class="user_info_txt">{{sender.representativeEmail}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.representativePhoneNumber')}}</label>
                                    <h4 v-if="sender.customerType === 1 ||sender.customerType === 2 ||sender.customerType === 3" class="user_info_txt"><span class="pr-3">+966</span> {{sender.representativeMobile}}</h4>
                                    <h4 v-if="sender.customerType === 4" class="user_info_txt">{{sender.representativeMobile}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="(userRole == 9|| userRole == 1) && sender.crExpiryDate !== '' && sender.customerType === 3">
                                    <label v-if="(userRole == 9|| userRole == 1) && sender.crExpiryDate !== '' && sender.customerType === 3" class="user_info_header mb-0">{{$t('shared.crExpiryDate')}}</label>
                                    <h4 v-if="(userRole == 9|| userRole == 1) && sender.crExpiryDate !== '' && sender.customerType === 3" class="user_info_txt">{{sender.crExpiryDate}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="(userRole == 9|| userRole == 1) && sender.companyName !== '' && sender.customerType === 3">
                                    <label v-if="(userRole == 9|| userRole == 1) && sender.companyName !== '' && sender.customerType === 3" class="user_info_header mb-0">{{$t('shared.companyName')}}</label>
                                    <h4 v-if="(userRole == 9|| userRole == 1) && sender.companyName !== '' && sender.customerType === 3" class="user_info_txt">{{sender.companyName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="(userRole == 9|| userRole == 1) && sender.representativeID !== ''&& sender.customerType === 3">
                                    <label v-if="(userRole == 9|| userRole == 1) && sender.representativeID !== '' && sender.customerType === 3" class="user_info_header mb-0">{{$t('shared.representativeID')}}</label>
                                    <h4 v-if="(userRole == 9|| userRole == 1) && sender.representativeID !== ''&& sender.customerType === 3" class="user_info_txt">{{sender.representativeID}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">
                                        {{ $t('shared.senderCriticality') }}
                                    </label>

                                    <!-- Editable -->
                                    <v-checkbox v-if="(userRole == 9|| userRole == 1) && (sender.requestStatus == 1||sender.requestStatus ==10)"
                                                v-model="sender.isCriticalSender"
                                                :label="$t('shared.criticalSender')" 
                                                  @change="saveCriticalSender"/>

                                    <!-- Read-only -->
                                    <h4 v-else
                                        class="user_info_txt">
                                        {{ sender.isCriticalSender ? $t('shared.critical'): $t('shared.notCritical')}}
                                    </h4>
                                </div>

                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.contractExpiryDate')}}</label>
                                    <h4 class="user_info_txt">{{sender.expiryDate}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.annualReferenceDate')}}</label>
                                    <h4 class="user_info_txt">{{sender.annualReferenceDate || '-'}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.duration')}}</label>
                                    <h4 class="user_info_txt">{{sender.duration}} {{$t('shared.year')}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.tenant')}}</label>
                                    <h4 class="user_info_txt">{{sender.tenant}}</h4>
                                </div>
                                <div class="col-md-12" v-if="sender.requestStatus == 3">
                                    <label class="user_info_header mb-3">{{$t('shared.rejectionReason')}}</label>
                                    <textarea rows="3" class="form-control" style="resize: none" v-model="sender.lastRejectionReason" readonly></textarea>
                                </div>
                                <div class="col-md-12" v-if="(sender.requestStatus == 1 || sender.requestStatus == 10) && sender.comment && sender.comment.trim()">
                                    <label class="user_info_header mb-3">{{$t('shared.comment')}}</label>
                                    <textarea rows="3" class="form-control" style="resize: none" v-model="sender.comment" readonly></textarea>
                                </div>
                                <div class="col-md-12" v-if="showPreviousGovernmentSection">
                                    <label class="user_info_header mb-3" style="font-weight: 700;">{{$t('shared.previousGovernmentSender')}}</label>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">{{$t('shared.clientName')}}</th>
                                                    <th class="text-center">{{$t('shared.representativeName')}}</th>
                                                    <th class="text-center">{{$t('shared.representativePhoneNumber')}}</th>
                                                    <th class="text-center">{{$t('shared.representativeEmail')}}</th>
                                                    <th class="text-center">{{$t('shared.supportingDocument')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">{{ sender.previousGovernmentClientName }}</td>
                                                    <td class="text-center">{{ sender.previousGovernmentRepresentativeName }}</td>
                                                    <td class="text-center">{{ sender.previousGovernmentRepresentativeMobile }}</td>
                                                    <td class="text-center">{{ sender.previousGovernmentRepresentativeEmail }}</td>
                                                    <td class="text-center">
                                                        <input type="file" ref="supportingDocumentFile" style="display: none;"
                                                            @change="onSupportingDocumentPicked" />
                                                        <i v-if="canUploadSupportingDocument"
                                                            class="fas fa-upload supporting-doc-upload-icon"
                                                            style="cursor: pointer; color: #9e9e9e;"
                                                            :title="$t('shared.upload')"
                                                            @click="triggerSupportingDocumentPick('supportingDocumentFile')"></i>
                                                        <i v-if="canDownloadSupportingDocument"
                                                            class="fas fa-download supporting-doc-download-icon"
                                                            style="cursor: pointer; color: #000000;"
                                                            :title="$t('shared.supportingDocument')"
                                                            @click="downloadSupportingDocument"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label>{{$t('shared.attachmentList')}}</label>
                                    <ul class="list-group list_Sender scrollbar">
                                        <li class="list-group-item" v-if="sender.senderRequestAttachments.length > 0" v-for="(item, index) in sender.senderRequestAttachments" :key="item">
                                            <lable class="box-name w-100">{{item.fileName}}</lable>
                                            <lable class="box-name w-100">{{item.attachmentTypeName}}</lable>
                                            <i class="fas fa-download" @click="DownloadFile(item)"></i>
                                        </li>
                                        <li class="list-group-item" v-if="sender.senderRequestAttachments.length == 0">
                                            {{$t('shared.noAttachments')}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <Progress :transitionDuration="1000"   :radius="120"  :strokeColor="checkColor(sender.requestStatus)" :strokeWidth="10" :value="getRate(sender.startDate, sender.duration)">
                                <div class="content">
                                    <h3 class="w-100"  :class="'status-' + sender.requestStatus">{{GetSenderStatus(sender.requestStatus)}}</h3>
                                    <p>
                                        {{sender.remainingDays}} {{$t('dashboardPage.of')}} {{sender.totalDays}} <br /> {{$t('dashboardPage.daysLeft')}}
                                    </p>
                                </div>
                            </Progress>
                        </div>
                        <div class="col-md-12 mt-5">
                            <div class="form-row justify-content-end align-items-center">
                                <div class="col-auto mx-3">
                                    <router-link to="/Dashboard" tag="a" class="link_secondary">{{$t('shared.back')}}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </v-tab-item>
                <!-- AI Attachment Review Tab -->
                <v-tab-item>
                    <div>
                        <div v-if="aiFailed" class="ai-note-alert ai-note--split">
                            <div class="ai-note-left">
                                <v-icon left color="orange darken-2" size="28" class="ai-note-icon">mdi-alert-circle</v-icon>
                                <div class="ai-note-text">
                                    <strong>{{ $t('shared.note') }}</strong>
                                    {{ aiFailedText }}
                                </div>
                            </div>
                            <v-btn v-show="showRecheck" :loading="recheckBusy" :disabled="recheckBusy" text :ripple="false"
                                class="ai-note-action" @click.stop.prevent="recheckAI">
                                <i size="28" class="mdi mdi-reload mr-1"></i>
                                {{ $t('shared.recheck') }}
                            </v-btn>
                        </div>

                        <div v-if="!aiFailed && invalidAttachmentNote" class="ai-note-alert">
                            <v-icon left color="orange darken-2" size="28" class="ai-note-icon">mdi-alert-circle</v-icon>
                            <div class="ai-note-text">
                                <strong>{{ $t('shared.note') }}</strong>
                                {{ invalidAttachmentNote }}
                            </div>
                        </div>
                        <template v-if="!aiFailed">
                        <v-data-table :headers="aiReviewHeaders" :items="aiReviewRows" hide-actions disable-hover
                            class="elevation-2 review-table">
                            <template v-slot:items="props">
                                <tr v-if="!(props.item.fieldKey === 'authorized_id' && sender.verificationType !== 1)">
                                    <td class="text-center" style="font-weight: 600; border-right: 1px solid #dcdcdc;">
                                        {{ props.item.fieldName }}
                                    </td>
                                    <td class="text-center" style="border-right: 1px solid #dcdcdc;">
                                        {{ props.item.providerInput }}
                                    </td>
                                    <td class="text-center" style="border-right: 1px solid #dcdcdc;">
                                        {{ props.item.aiResult }}
                                    </td>
                                    <td class="text-center">
                                         <v-chip small outlined class="status-chip"
                                            :color="props.item.status === 0 ? 'green lighten-4' : props.item.status === 1 ? 'red lighten-4' : 'orange lighten-4'"
                                            :text-color="props.item.status === 0 ? 'green' : props.item.status === 1 ? 'red' : 'orange'">
                                            {{ aiStatusText(props.item.status) }}
                                            <v-icon right small :color="statusColor(props.item.status)">
                                                {{ statusIcon(props.item.status) }}
                                            </v-icon>
                                        </v-chip> 
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                        <div v-if="aiStamps">
                            <div class="stamp-card elevation-2 mt-5">
                                <div class="card-header enhanced-card-header">
                                    <span>{{ $t('shared.stampVerification') }}</span>
                                </div>
                                <div class="card-body">
                                    <div class="d-flex flex-wrap justify-content-center stamp-list">
                                        <div v-for="stamp in stampList" :key="stamp.key" class="stamp-chip align-items-center">                               
                                            <span class="stamp-icon" :class="aiStamps[stamp.prop] ? 'stamp-success' : 'stamp-error'">
                                                <v-icon size="20" :color="aiStamps[stamp.prop] ? 'green' : 'red'">
                                                    {{ aiStamps[stamp.prop] ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                                </v-icon>
                                            </span>                                
                                            <span class="stamp-title">
                                                {{ $t('shared.' + stamp.key) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                        <div class="col-md-12 mt-5">
                            <div class="form-row justify-content-end align-items-center">
                                <div class="col-auto mx-3">
                                    <router-link to="/Dashboard" tag="a" class="link_secondary">{{$t('shared.back')}}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-tab-item>
                </v-tabs-items>
                </template>
                <template v-else>
                    <div>
                        <div class="row">                               
                            <div v-if="showScamListWarning" class="col-md-9">
                                <v-icon x-large style="color:red">warning_amber</v-icon><span style="color: red; top: -10px; position: relative;" v-html="scamListWarningHtml"></span>
                            </div>
                        </div>
                    <div class="row">
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('dashboardPage.senderName')}}</label>
                                    <img v-if="sender.isAutoSuggested && (userRole == 1 || userRole == 9 || userRole == 15)" 
                                         :title="$t('shared.senderNameByAI')"
                                         :src="require('../../img/AISuggested.png')" alt="Icon" style="width: 20px; height: 20px; margin-right: 8px;" />
                                    <h4 class="user_info_txt">{{sender.senderName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.senderType')}}</label>
                                    <h4 class="user_info_txt">
                                        <span v-for="(type, index) in senderType" :key="type">
                                            {{getSenderTypeText(type)}}
                                        </span>
                                    </h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.domainName">
                                    <label class="user_info_header mb-0">{{ $t('shared.domainName') }}</label>
                                    <h4 class="user_info_txt">{{ sender.domainName }}</h4>
                                </div>                                
                                <div class="col-sm-4 mb-3" v-if="sender.hasTrademark">
                                    <label class="user_info_header mb-0">{{ $t('shared.trademarkName') }}</label>
                                    <h4 class="user_info_txt">{{ sender.trademarkName }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.hasTrademark">
                                    <label class="user_info_header mb-0">{{ $t('shared.protectionDateFrom') }}</label>
                                    <h4 class="user_info_txt">{{ sender.protectionDateFrom }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.hasTrademark">
                                    <label class="user_info_header mb-0">{{ $t('shared.protectionDateTo') }}</label>
                                    <h4 class="user_info_txt">{{ sender.protectionDateTo }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="(userRole != 2  && userRole != 5)">
                                    <label class="user_info_header mb-0">{{$t('shared.providerName')}}</label>
                                    <h4 class="user_info_txt">{{sender.providerName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.clientName')}}</label>
                                    <h4 class="user_info_txt">{{sender.clientName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.customerType !== 3">
                                    <label class="user_info_header mb-0" v-if="sender.customerType === 1">{{$t('shared.budgetNumber')}}</label>
                                    <label class="user_info_header mb-0" v-if="sender.customerType === 2">{{$t('shared.licenseNumber')}}</label>
                                    <label class="user_info_header mb-0" v-if="sender.customerType === 4">{{$t('shared.internationalCommercialRegistrationNumber')}}</label>
                                    <h4 class="user_info_txt no-collapse">{{sender.crNumber}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="sender.customerType === 2 ||sender.customerType === 3">
                                    <label class="user_info_header mb-0">{{$t('shared.enterpriseUnifiedNumber')}}</label>
                                    <img v-if="sender.verificationType == 1  && (userRole == 1 || userRole == 9 || userRole == 15)" 
                                         :title="$t('shared.crAutoVerificationSuccess')"
                                         :src="require('../../img/success_tick_icon.svg')" alt="Icon" style="width: 20px; height: 20px; margin-right: 8px;"/>
                                    <h4 class="user_info_txt no-collapse">{{sender.enterpriseUnifiedNumber}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.customerType')}}</label>
                                    <h4 class="user_info_txt">{{getCustomerTypeText(sender.customerType)}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.representativeName')}}</label>
                                    <h4 class="user_info_txt">{{ maskedRepresentativeName }}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.representativeEmail')}}</label>
                                    <h4 class="user_info_txt">{{sender.representativeEmail}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.representativePhoneNumber')}}</label>
                                    <h4 v-if="sender.customerType === 1 ||sender.customerType === 2 ||sender.customerType === 3" class="user_info_txt"><span class="pr-3">+966</span> {{sender.representativeMobile}}</h4>
                                    <h4 v-if="sender.customerType === 4" class="user_info_txt">{{sender.representativeMobile}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="(userRole == 9|| userRole == 1) && sender.crExpiryDate !== '' && sender.customerType === 3">
                                    <label v-if="(userRole == 9|| userRole == 1) && sender.crExpiryDate !== '' && sender.customerType === 3" class="user_info_header mb-0">{{$t('shared.crExpiryDate')}}</label>
                                    <h4 v-if="(userRole == 9|| userRole == 1) && sender.crExpiryDate !== '' && sender.customerType === 3" class="user_info_txt">{{sender.crExpiryDate}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="(userRole == 9|| userRole == 1) && sender.companyName !== '' && sender.customerType === 3">
                                    <label v-if="(userRole == 9|| userRole == 1) && sender.companyName !== '' && sender.customerType === 3" class="user_info_header mb-0">{{$t('shared.companyName')}}</label>
                                    <h4 v-if="(userRole == 9|| userRole == 1) && sender.companyName !== '' && sender.customerType === 3" class="user_info_txt">{{sender.companyName}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3" v-if="(userRole == 9|| userRole == 1) && sender.representativeID !== ''&& sender.customerType === 3">
                                    <label v-if="(userRole == 9|| userRole == 1) && sender.representativeID !== '' && sender.customerType === 3" class="user_info_header mb-0">{{$t('shared.representativeID')}}</label>
                                    <h4 v-if="(userRole == 9|| userRole == 1) && sender.representativeID !== ''&& sender.customerType === 3" class="user_info_txt">{{sender.representativeID}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.senderCriticality')}}</label>
                                    <h4 v-if="sender.isCriticalSender" class="user_info_txt">{{$t('shared.critical')}}</h4>
                                    <h4 v-if="!sender.isCriticalSender" class="user_info_txt">{{$t('shared.notCritical')}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.contractExpiryDate')}}</label>
                                    <h4 class="user_info_txt">{{sender.expiryDate}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.annualReferenceDate')}}</label>
                                    <h4 class="user_info_txt">{{sender.annualReferenceDate || '-'}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.duration')}}</label>
                                    <h4 class="user_info_txt">{{sender.duration}} {{$t('shared.year')}}</h4>
                                </div>
                                <div class="col-sm-4 mb-3">
                                    <label class="user_info_header mb-0">{{$t('shared.tenant')}}</label>
                                    <h4 class="user_info_txt">{{sender.tenant}}</h4>
                                </div>
                                <div class="col-md-12" v-if="sender.requestStatus == 3">
                                    <label class="user_info_header mb-3">{{$t('shared.rejectionReason')}}</label>
                                    <textarea rows="3" class="form-control" style="resize: none" v-model="sender.lastRejectionReason" readonly></textarea>
                                </div>
                                <div class="col-md-12" v-if="(sender.requestStatus == 1 || sender.requestStatus == 10) && sender.comment && sender.comment.trim()">
                                    <label class="user_info_header mb-3">{{$t('shared.comment')}}</label>
                                    <textarea rows="3" class="form-control" style="resize: none" v-model="sender.comment" readonly></textarea>
                                </div>
                                <div class="col-md-12" v-if="showPreviousGovernmentSection">
                                    <label class="user_info_header mb-3" style="font-weight: 700;">{{$t('shared.previousGovernmentSender')}}</label>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th class="text-center">{{$t('shared.clientName')}}</th>
                                                    <th class="text-center">{{$t('shared.representativeName')}}</th>
                                                    <th class="text-center">{{$t('shared.representativePhoneNumber')}}</th>
                                                    <th class="text-center">{{$t('shared.representativeEmail')}}</th>
                                                    <th class="text-center">{{$t('shared.supportingDocument')}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="text-center">{{ sender.previousGovernmentClientName }}</td>
                                                    <td class="text-center">{{ sender.previousGovernmentRepresentativeName }}</td>
                                                    <td class="text-center">{{ sender.previousGovernmentRepresentativeMobile }}</td>
                                                    <td class="text-center">{{ sender.previousGovernmentRepresentativeEmail }}</td>
                                                    <td class="text-center">
                                                        <input type="file" ref="supportingDocumentFileAlt" style="display: none;"
                                                            @change="onSupportingDocumentPicked" />
                                                        <i v-if="canUploadSupportingDocument"
                                                            class="fas fa-upload supporting-doc-upload-icon"
                                                            style="cursor: pointer; color: #9e9e9e;"
                                                            :title="$t('shared.upload')"
                                                            @click="triggerSupportingDocumentPick('supportingDocumentFileAlt')"></i>
                                                        <i v-if="canDownloadSupportingDocument"
                                                            class="fas fa-download supporting-doc-download-icon"
                                                            style="cursor: pointer; color: #000000;"
                                                            :title="$t('shared.supportingDocument')"
                                                            @click="downloadSupportingDocument"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label>{{$t('shared.attachmentList')}}</label>
                                    <ul class="list-group list_Sender scrollbar">
                                        <li class="list-group-item" v-if="sender.senderRequestAttachments.length > 0" v-for="(item, index) in sender.senderRequestAttachments" :key="item">
                                            <lable class="box-name w-100">{{item.fileName}}</lable>
                                            <lable class="box-name w-100">{{item.attachmentTypeName}}</lable>
                                            <i class="fas fa-download" @click="DownloadFile(item)"></i>
                                        </li>
                                        <li class="list-group-item" v-if="sender.senderRequestAttachments.length == 0">
                                            {{$t('shared.noAttachments')}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <Progress :transitionDuration="1000"   :radius="120"  :strokeColor="checkColor(sender.requestStatus)" :strokeWidth="10" :value="getRate(sender.startDate, sender.duration)">
                                <div class="content">
                                    <h3 class="w-100"  :class="'status-' + sender.requestStatus">{{GetSenderStatus(sender.requestStatus)}}</h3>
                                    <p>
                                        {{sender.remainingDays}} {{$t('dashboardPage.of')}} {{sender.totalDays}} <br /> {{$t('dashboardPage.daysLeft')}}
                                    </p>
                                </div>
                            </Progress>
                        </div>
                        <div class="col-md-12 mt-5">
                            <div class="form-row justify-content-end align-items-center">
                                <div class="col-auto mx-3">
                                    <router-link to="/Dashboard" tag="a" class="link_secondary">{{$t('shared.back')}}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </template>
                </div>
                </div>
            </div>
        </div>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="showSenderRequestTransactionsdialog" :width="(userRole == 3 || userRole == 4) ? 900 : 554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t((userRole == 3 || userRole == 4) ? 'shared.senderActivityHistory' : 'shared.SenderRequestActionsInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideshowSenderRequestTransactionsdialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <template v-if="userRole == 3 || userRole == 4">
                        <div v-if="senderActivityHistoryLoading" class="py-4">
                            <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        </div>
                        <div v-else-if="senderActivityHistoryError" class="py-4">
                            {{$t('shared.errorOccurred')}}
                        </div>
                        <div v-else-if="senderActivityHistoryLoaded && SenderRequestTransactions.length === 0" class="py-4">
                            {{$t('senderInfo.noActivityHistory')}}
                        </div>
                        <template v-else-if="senderActivityHistoryLoaded && SenderRequestTransactions.length > 0">
                            <v-data-table :headers="headers"
                                          :items="SenderRequestTransactions"
                                          hide-actions
                                          class="elevation-1 table-striped">
                                <template v-slot:items="props">
                                    <tr>
                                        <td class="text-center">{{ props.item.requestStatus }}</td>
                                        <td class="text-center">{{ props.item.createdDate }}</td>
                                        <td class="text-center">{{ formatProcessedBy(props.item.processedBy) }}</td>
                                        <td class="text-center">{{ props.item.comment }}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </template>
                    </template>
                    <template v-else>
                        <v-data-table :headers="legacyHeaders"
                                      :items="SenderRequestTransactions"
                                      hide-actions
                                      class="elevation-1 table-striped">
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-center">{{ props.item.requestStatus }}</td>
                                    <td class="text-center">{{ props.item.createdDate }}</td>
                                    <td class="text-center">{{ props.item.comment }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="showExtendRequestsdialog" width="600">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.extendRequest')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideExtendRequestsdialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <template>
                        <v-data-table :headers="extendRequestHeaders"
                                      :items="senderRequestExtendViewModel"
                                      hide-actions
                                      class="elevation-1 table-striped">
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-center">{{ props.item.extendRequestId }}</td>
                                    <td class="text-center">{{ props.item.duration }}</td>
                                    <td class="text-center">{{ props.item.requestStatus }}</td>
                                    <td class="text-center">{{ props.item.createdDate }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="resendDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.resendInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideresendDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.comment')}}</label>
                                <input v-model="resendComment" class="form-control " type="text" />
                            </div>
                        </div>
                    </div>
                    <p class="mt-3">
                        {{$t('shared.resendInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideresendDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="resend('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="finalApproveDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.finalApproveInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideFinalApproveDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <p class="mt-3">
                        {{$t('shared.finalApproveInputText')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideFinalApproveDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="finalApprove('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="approveDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.approveInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideapproveDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.comment')}}</label>
                                <input v-model="approveComment" class="form-control " type="text" />
                            </div>
                        </div>
                    </div>
                    <p class="mt-3">
                        {{$t('shared.approveInputText')}}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideapproveDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="approve('')">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="deactivateDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.deactivateInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="cancelDeactivateDialog()"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text-center">
                    <p class="mt-3">
                        {{$t('shared.deactivateInputTextSingle')}}
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="cancelDeactivateDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="deactivate">{{$t('shared.yes')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="deleteDialog" persistent width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.deleteInput')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideDeleteDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text class="text">
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>{{$t('dashboardPage.comment')}}</label>
                                <input v-model="deleteComment" class="form-control " type="text" />
                            </div>
                        </div>
                    </div>
                    <p class="mt-3">
                        {{$t('shared.deletesenderInputText')}}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideDeleteDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="deleteSender">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="rejectdialog" persistent width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('dashboardPage.reject')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideRejectDialog"></i>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <reject-reason-multi-select
                                :items="popUpRejectionReasons"
                                :value="selectedRejectReasons"
                                :other-text="otherRejectReasonText"
                                :disabled="rejectReasonsLocked"
                                @input="onRejectReasonsChanged"
                                @other-text="onOtherRejectTextChanged">
                            </reject-reason-multi-select>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideRejectDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" :disabled="!rejectReasonIsValid" @click="reject">{{$t('shared.Ok')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    </div>
</div>